import crews from "csi/access/crews";
import ActionConstructor, { Action } from "csi/def/Action";
import ViewRefConstructor from "csi/def/ViewRef";
import AggregateController from "csi/heading/AggregateController";
import _AggregateWithNewMixin from "csi/heading/_AggregateWithNewMixin";
import declare from "dojo/_base/declare";
import lang from "dojo/_base/lang";

export =  declare([AggregateController, _AggregateWithNewMixin], {
	aggregateNewNodeType: "HiggMaterial",

	/**
	 * @override
	 * specify the view to navigate to 
	 */
	_getNewAction(): Action {
		/** check whether or not the roles can play the admin role */
		if (!crews.isInRoles(["Higg Material Administrator"])) {
			return null;
		}

		return lang.mixin(new ActionConstructor(), {
			m_id: "New" + this.aggregateNewNodeType,
			m_typeNode: this.aggregateNewNodeType,
			m_viewRef: lang.mixin(new ViewRefConstructor(), {
				m_id: "NewHiggMaterialWizard",
				m_url: "centric://REFLECTION/INSTANCE/_CS_Data/null",
			}),
		});
	},
});